import React from "react";
import { Typography, Box, Button, Stack } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export default function VideoEmbed({ channel_type, videoId, channelHandle, channelUrl }) {
    const t = (channel_type || "").toLowerCase();
    const proxyPrefix = "https://1855proxy.xyz/?";
    const withProxy = (url) => `${proxyPrefix}${url}`;
    const normalizedHandle = (channelHandle || "").replace(/^@/, "");
    const safeVideoId = encodeURIComponent(videoId || "");
    const tikTokVideoUrl =
        normalizedHandle && videoId
            ? `https://www.tiktok.com/@${normalizedHandle}/video/${safeVideoId}`
            : null;
    const tikTokSearchUrl = videoId
        ? `https://www.tiktok.com/search?q=${safeVideoId}`
        : "https://www.tiktok.com/";
    let embed;

    switch (t) {
        case "youtube":
        case "youtubeshort":
            embed = (
                <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
                    <iframe
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title="YouTube video"
                        frameBorder="0"
                        allowFullScreen
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: "8px"
                        }}
                    />
                </div>
            );
            break;

        case "tiktok":
            embed = (
                <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                        TikTok preview
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        TikTok embeds are disabled here. Open the original post in a new tab.
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap">
                        {tikTokVideoUrl && (
                            <Button
                                size="small"
                                variant="contained"
                                endIcon={<OpenInNewIcon />}
                                component="a"
                                href={withProxy(tikTokVideoUrl)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Open post
                            </Button>
                        )}
                        <Button
                            size="small"
                            variant="outlined"
                            endIcon={<OpenInNewIcon />}
                            component="a"
                            href={withProxy(tikTokVideoUrl || tikTokSearchUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Find video
                        </Button>
                        {channelUrl && (
                            <Button
                                size="small"
                                variant="text"
                                endIcon={<OpenInNewIcon />}
                                component="a"
                                href={withProxy(channelUrl)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Channel
                            </Button>
                        )}
                    </Stack>
                </Box>
            );
            break;

        default:
            embed = (
                <Box textAlign="center" p={2} color="text.secondary">
                    This content cannot be shown right now.
                </Box>
            );
    }

    return (
        <Box sx={{  mx: "auto" }}>
            
                {embed}
            
            
        </Box>
    );
}
